import { ECommerceStatus } from "src/ssc-api/useECommerceStatus";
import { FareCode } from "@silversea-ssc/web-fares";
import { CruisePriceFeature } from "@silversea-ssc/dotcom-api-types/CruisePriceAndOffersV2";
import { match, P } from "ts-pattern";

export const tryAppendFareParam = (
  url: ECommerceStatus | undefined,
  fareCode: FareCode,
  features: readonly CruisePriceFeature[]
): ECommerceStatus | undefined => {
  if (!url) return undefined;

  const withAir = features.includes("AirAndSea");
  const fareParam = match([fareCode, withAir])
    .with(["DoorToDoorV2", true], () => "DoorToDoorV2-flights")
    .with(["DoorToDoorV2", false], () => undefined)
    .with(
      [
        P.union("PortToPortV2", "Essential", "Plus", "Basic", "LastMinute"),
        P.boolean
      ],
      ([fare]) => `${fare}-no-flights`
    )
    .exhaustive();

  if (!fareParam) return url;

  return match(url)
    .with({ type: "ecommerce" }, (u) => ({
      ...u,
      ecommerceUrl: appendFareParam(u.ecommerceUrl, fareParam),
      priceConfigUrl: appendFareParam(u.priceConfigUrl, fareParam)
    }))
    .with({ type: "priceconfig" }, (u) => ({
      ...u,
      url: appendFareParam(u.url, fareParam)
    }))
    .otherwise(() => url);
};

const appendFareParam = (url: string, fareParam: string) => {
  const urlObj = new URL(url);
  urlObj.searchParams.set("fare", fareParam);
  return urlObj.href;
};
